import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import MessageBlock from '../../../../../../../../features/components/Form/MessageBlock'

import { getAppDomainName } from '../../../../../../../../features/helpers/getAppDomainName'
import { capitalizeFirstLetter } from '../../../../../../../../helpers/common'

import { selfAccountSelector } from '../../../../../../../../modules/selectors/selfAccounts'

import { FACEBOOK_BUSINESS_MANAGER_ID } from '../../../../../../../../pages/Settings/RightHolderProfile/fields'

import useStyles from '../styles'

const MissingDatasetsAndCustomConversionWarningMessage = () => {
  const classes = useStyles()

  const { t } = useTranslation()

  const selfAccount = useSelector(selfAccountSelector)
  const selfAccountFacebookBmId = selfAccount?.[FACEBOOK_BUSINESS_MANAGER_ID]
  const appName = getAppDomainName()

  return (
    <MessageBlock title="MISSING DATASET OR CUSTOM CONVERSION" borderColor="warning" className={classes.messageBlock}>
      Please confirm the{' '}
      <a
        className={classes.link}
        rel="noreferrer nofollow"
        target="_blank"
        href={`https://business.facebook.com/latest/settings/events_dataset?business_id=${selfAccountFacebookBmId}`}
      >
        dataset
      </a>{' '}
      or{' '}
      <a
        className={classes.link}
        rel="noreferrer nofollow"
        target="_blank"
        href={`https://business.facebook.com/latest/settings/custom_conversions?business_id=${selfAccountFacebookBmId}`}
      >
        custom conversion
      </a>{' '}
      has been shared with business manager ID {selfAccountFacebookBmId} and request for it to be linked to this{' '}
      {capitalizeFirstLetter(appName.toLowerCase())} account. {t('Otherwise, please select another goal.')}
    </MessageBlock>
  )
}

export default MissingDatasetsAndCustomConversionWarningMessage
